import React from "react";

interface Props { current: number; }

const STEPS = ["Date & Time", "Your Details", "Address"];

export function StepIndicator({ current }: Props) {
  return (
    <div style={{ display:"flex", alignItems:"center", marginBottom:28, overflowX:"auto", paddingBottom:4 }}>
      {STEPS.map((s, i) => {
        const done = i < current, active = i === current;
        return (
          <React.Fragment key={i}>
            <div style={{ display:"flex", flexDirection:"column", alignItems:"center", gap:5, flexShrink:0 }}>
              <div style={{ width:32, height:32, borderRadius:"50%", background:done?"var(--success)":active?"var(--indigo)":"var(--surface2)", border:`2px solid ${done?"var(--success)":active?"var(--indigo)":"var(--border)"}`, display:"flex", alignItems:"center", justifyContent:"center", fontSize:13, fontWeight:700, color:done||active?"#fff":"var(--text3)", transition:"all 0.3s" }}>
                {done ? "✓" : i + 1}
              </div>
              <span style={{ fontSize:11, fontWeight:600, whiteSpace:"nowrap", color:active?"var(--indigo)":done?"var(--success)":"var(--text3)" }}>{s}</span>
            </div>
            {i < STEPS.length - 1 && (
              <div style={{ flex:1, height:2, margin:"0 6px", marginBottom:18, minWidth:16, background:done?"var(--success)":"var(--border)", transition:"background 0.3s" }} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
}
